"use client"
import { useLanguage } from "../context/LanguageContext"
import { useTranslations } from "../translations"

const LanguageSelector = () => {
  const { language, setLanguage } = useLanguage()

  const handleLanguageChange = (e) => {
    setLanguage(e.target.value)
  }
  const { t } = useTranslations()
  return (
    <div className="language-selector">
      <select
        value={language}
        onChange={handleLanguageChange}
        style={{
          background: "linear-gradient(135deg, var(--pink-bright) 0%, var(--orange-bright) 100%)",
          color: "white",
          border: "none",
          borderRadius: "12px",
          padding: "8px 16px",
          fontSize: "14px",
          fontWeight: "600",
          cursor: "pointer",
          outline: "none",
          minWidth: "120px",
          boxShadow: "0 4px 15px rgba(235, 33, 120, 0.2)",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = "translateY(-2px)"
          e.target.style.boxShadow = "0 6px 20px rgba(235, 33, 120, 0.3)"
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = "translateY(0)"
          e.target.style.boxShadow = "0 4px 15px rgba(235, 33, 120, 0.2)"
        }}
      >
        <option value="es" style={{ background: "var(--plum-bg)", color: "white" }}>
           🇪🇸 {t("spanish")}
        </option>
        <option value="en" style={{ background: "var(--plum-bg)", color: "white" }}>
           🇺🇸 {t("english")}
        </option>
        <option value="ta" style={{ background: "var(--plum-bg)", color: "white" }}>
          🇮🇳 {t("tamil")}
        </option>
      </select>
    </div>
  )
}

export default LanguageSelector
